import { BookInvoiceCommand, InvoiceReadModel, InvoiceType } from "../../GeneratedClients/FreeBillApi"
import validateBookingPeriod from "./validateBookingPeriod"
import validateInvoiceItems from "./validateInvoiceItems"

export type BookSkipReason =
  | "alreadyBooked"
  | "saleCarInvoice"
  | "invalidPeriod"
  | "invalidItems"

export type BookCheckResult =
  | { ok: true }
  | { ok: false; reason: BookSkipReason }

export const canBookInvoice = (invoice: InvoiceReadModel): BookCheckResult => {
  if (invoice.bookingInfos !== null && invoice.bookingInfos !== undefined) return { ok: false, reason: "alreadyBooked" }
  if (invoice.invoiceType === InvoiceType.SaleCarInvoice)                  return { ok: false, reason: "saleCarInvoice" }
  if (!invoice.invoiceDate || !validateBookingPeriod(new Date(invoice.invoiceDate))) return { ok: false, reason: "invalidPeriod" }
  if (!invoice.invoiceItems || !validateInvoiceItems(invoice.invoiceItems))          return { ok: false, reason: "invalidItems" }
  return { ok: true }
}

export const buildBookInvoiceCommand = (invoice: InvoiceReadModel): BookInvoiceCommand => ({
  userId: invoice.userId,
  correlationId: invoice.correlationId,
  invoiceDate: invoice.invoiceDate,
  invoiceNumber: invoice.invoiceNumber,
  invoiceRecipient: invoice.invoiceRecipient,
  invoiceType: invoice.invoiceType,
  invoiceItems: invoice.invoiceItems,
  uploadedFileId: invoice.uploadedFileId,
})
